// useQueuedSendDrain — dreno da fila de envio (BUG: mandar msg enquanto roda não
// podia enfileirar). Quando o turno termina (rodando→parado, seja fim normal, Stop
// ou watchdog — todos passam por `running` virar false), despacha o PRÓXIMO envio
// enfileirado (agentRunStore.takeNextQueued). Dreno FIFO sequencial: cada run que
// fecha puxa o próximo. Enfileirar acontece no composer (enqueueSend) só enquanto roda.
//
// Extraído do SessionWorkspace pra manter o componente sob o teto dp-loc e testável.

import { useEffect, useRef } from 'react';
import { takeNextQueued } from '../../../lib/agentRunStore.js';

/**
 * @param {{ sessionId: string, running: boolean, handleSendRef: { current: (payload:any)=>any } }} cfg
 */
export function useQueuedSendDrain({ sessionId, running, handleSendRef }) {
  const prevRunningRef = useRef(false);
  useEffect(() => {
    const was = prevRunningRef.current;
    prevRunningRef.current = running;
    if (was && !running) {
      const next = takeNextQueued(sessionId);
      if (next) handleSendRef?.current?.(next);
    }
  }, [running, sessionId, handleSendRef]);
}
